<template>
  <div>
    <router-view />
    <template v-if="!isFooterHidden">
      <div class="box1">
        <div class="widthBox">
          <div class="box2">
            <div class="imgWrap logo"><img src="/img/logoBg.png" alt="LOGO"></div>
            <div class="box3">
              <Row :gutter="10">
                <Col :lg="12" :sm="24">
                  <Icon type="ios-call" class="footerIcon" />
                  <span>组委会电话：010-88083947/2319</span>
                </Col>
                <Col :lg="12" :sm="24">
                  <Icon type="ios-phone-portrait" class="footerIcon" />
                  <span>联系人：13901127933（刘秀明）</span>
                </Col>
              </Row>
              <Row :gutter="10">
                <Col :lg="12" :sm="24">
                  <Icon type="md-mail" class="footerIcon" />
                  <span>组委会邮箱：cbmea2006@126.com</span>
                </Col>
                <Col :lg="12" :sm="24">
                  <Icon type="ios-chatbubbles" class="footerIcon" />
                  <span>微信公众号：国家建筑应用创新大奖</span>
                </Col>
              </Row>
              <p>
                <Icon type="md-pin" class="footerIcon" />
                <span>组委会地址：北京市海淀区三里河路甲11号 中国建材大厦C座3层</span>
              </p>
            </div>
            <div class="imgWrap weixin">
              <img src="/img/wxCode.jpg" alt="微信公众号">
              <p class="center size12">微信公众号</p>
            </div>  
          </div>
        </div>
        
      </div>
      <div class="copyright">
        <div class="widthBox">
          <p class="copyrightText">京ICP备17011295号-4 建筑应用创新大奖 版权所有</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    isFooterHidden() {
      return this.$route.meta.footerHidden
    }
  }
}
</script>

<style lang="scss" scoped>
.box1{
  background: #01735A;
  color: #fff;
  .box2{
    position: relative;
    margin: auto;
    padding: 15px 120px;
    .box3{
      background: #046651;
      line-height: 3em;
      margin: 15px 0;
      padding: 10px 30px;
      .footerIcon{
        font-size: 18px;
        margin-right: 5px;
      }
    }
    .imgWrap{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 90px;
      img{
        width: 100%;
      }
    }
    .logo{
      left: 10px;
    }
    .weixin{
      right: 10px;
    }
  }
}
.copyright{
  background: #DABB85;
  color: #000607;
  text-align: right;
  padding: 15px 15px;
  .copyrightText{
    font-size: 14px;
  }
}
@media screen and (max-width: 768px) {
  .box1 .box2 {
    padding: 30px 15px;

    .imgWrap{
      position: relative;
      top: 0;
      transform: translateY(0);
      margin: auto;
    }
    .logo{
      left: 0;
    }
    .weixin{
      right: 0;
    }
  }
}
</style>